import { BrokePowerRankPointer } from './BrokePowerRankPointer'
import { BrokePowerOfRebalancingPointer } from './BrokePowerOfRebalancingPointer'
import { useBottomSheet } from '../../../../../../state-management/contexts/BottomSheetContext'
import { ViewAllBenefitsBottomSheet } from '../../../../../BottomSheetComponents/ViewAllBenefitsBottomSheet'
import { lightImpactVibrate } from '../../../../../../utils/appBridge'
import { useAppMetaContent } from '../../../../../../state-management/providers/AppMetaContentProvider'
import { useEliteBuyCtaExtras } from '../../../../EliteBuyCtaExtrasContext'

interface BrokeEliteBenefitsSectionProps {
  sectionRef?: React.RefObject<HTMLDivElement>
  screenType?: string
}

export const BrokeEliteBenefitsSection = ({
  sectionRef,
  screenType = 'ELITE_LANDING_PAGE_1L'
}: BrokeEliteBenefitsSectionProps) => {
  const { openBottomSheet, closeBottomSheet } = useBottomSheet()
  const { getEliteMembersDisplay } = useAppMetaContent()
  // In-page section: read context here and hand it to the portal sheet as a prop.
  const buyCtaExtras = useEliteBuyCtaExtras()

  const handleViewAllBenefitsClick = () => {
    lightImpactVibrate()
    openBottomSheet(
      <ViewAllBenefitsBottomSheet
        onDismiss={() => {
          closeBottomSheet()
        }}
        ScreenName={screenType || 'ELITE_LANDING_PAGE_1L'}
        buyCtaExtras={buyCtaExtras}
      />
    )
  }

  return (
    <div className='flex flex-col bg-white pb-2 rounded-lg'>
      <div ref={sectionRef} className='rounded-lg bg-white pt-8 pb-1 relative z-0 overflow-hidden'>
        <div className='absolute top-0 w-full z-[-1] mt-[-40px]'>
          <img
            src='/images/elite/elite_benefits_lines.svg'
            alt=''
            aria-hidden='true'
            className='w-full h-auto'
          />
        </div>
        <div className='px-5'>
          <h2 className='text-[15px] font-[500] text-[#232323] leading-[100%]'>What you get with Elite?</h2>
        </div>
        <ul className='list-none m-0 p-0'>
          <li className='pt-8 px-5 pb-5 list-none'>
            <BrokePowerRankPointer memberCount={getEliteMembersDisplay('long')} />
          </li>
          <li className='pt-8 px-5 pb-5 list-none border-t'>
            <BrokePowerOfRebalancingPointer />
          </li>
        </ul>
        <div className='px-5 pb-5'>
          <button
            type='button'
            onClick={handleViewAllBenefitsClick}
            aria-label='View all benefits'
            aria-description='Double tap to view all available benefits'
            className='!w-full h-[56px] bg-white border-[1px] border-[#EBF2F2] focus:outline-none rounded-xl py-2 cursor-pointer'
          >
            <span className='text-sm' aria-hidden='true'>
              View all benefits
            </span>
          </button>
        </div>
      </div>
    </div>
  )
}
